import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../hoc/Loading/Loading";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import axios from "../../axios";
import * as url from "../../utils/url";
import { Container, Row, Col, Table } from "reactstrap";
import moment from "moment";
import { toolkitCategories } from "../../utils/categories";
import ReactPlayer from "react-player/lazy";
import { uploadPreview } from "../../utils/constants";
import ImagePreview from "../../components/Previews/ImagePreview";

class StoriesPhotoGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachments: [],
    };
  }

  componentDidMount() {
    this.setState({ attachments: this.props.attachments });
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.attachments) !==
      JSON.stringify(nextProps.attachments)
    ) {
      this.setState({ attachments: nextProps.attachments });
    }
  }

  generateRand = modArr => {
    return modArr[Math.floor(Math.random() * modArr.length)];
  };

  renderGridFormat = (length, startSet) => {
    // let isVideo = startSet.filter(e=> e.type&&e.type.mime&&e.type.mime.indexOf('video')>-1  ).length>0
    let videoIdx = startSet.findIndex(
      x => x.type && x.type.mime.indexOf("video") > -1
    );

    let gridEl = startSet[1];
    // gridEl = modArr[0]
    // let gridEl2 =  this.generateRand(modArr)
    // (modArr.findIndex(e=>e.url==gridEl.url)) == modArr.length-1
    // let gridEl2 = 0 != modArr.length-1? modArr[(modArr.findIndex(e=>e.url==gridEl.url)) +1]:gridEl
    let gridEl2 = length >= 3 ? startSet[2] : false;

    return (
      <div className={`container grid${length} imgFixContainer`}>
        {startSet.map((itm, idx) => {
          let isGridStyle = "";
          if (idx != 0) {
            isGridStyle =
              itm.url == gridEl.url
                ? 1
                : length > 3
                ? itm.url == gridEl2.url
                  ? 2
                  : false
                : false;
          }
          return this.renderGrid(length, itm, idx, videoIdx, isGridStyle);
        })}
      </div>
    );
  };

  renderGrid = (length, itm, idx, videoIdx, isGridStyle) => {
    let result;
    let itmPreview = uploadPreview(itm);
    let previewItm = itmPreview.url;

    let urlImage = itmPreview.isMsIcon
      ? itmPreview
      : itmPreview.preview && itmPreview.preview.length > 0
      ? itmPreview.preview
      : itmPreview.url;

    if (idx == 0) {
      if (itm.type && itm.type.mime && itm.type.mime.indexOf("video") > -1) {
        result = (
          <div className={`big${length} idx_${idx} ${ itm.type.mime.indexOf("video") > -1?'is-vid-css':''}`} key={idx}>
            <ReactPlayer
              width="100%"
              height="100%"
              // controls={true}
              url={itmPreview.preview}
            />
          </div>
        );
      } else {
        if (itmPreview.isMsIcon) {
          result = (
            <div className={`big${length} idx_${idx}`} key={idx}>
              <ImagePreview item={itmPreview} />
            </div>
          );
        } else {
          result = (
            <div className={`big${length} idx_${idx}`} key={idx}>
              <div
                className="stories_photo_grid_bg_image_blur"
                style={{
                  backgroundImage: itmPreview.isMsIcon
                    ? urlImage
                    : `url(${urlImage})`,
                }}
              />
              <img
                className={`${itmPreview.isMsIcon ? "storiesGridMsIcon" : ""}`}
                src={itmPreview.preview}
              />
            </div>
          );
        }
      }
    } else {
      if (length == 2) {
        result = (
          <div className={`vertical2 grp${length} ${ itm.type.mime.indexOf("video") > -1?'is-vid-css':''}`} key={idx}>
            {itm.type &&
            itm.type.mime &&
            itm.type.mime.indexOf("video") == -1 &&
            !itmPreview.isMsIcon ? (
              <div
                className="stories_photo_grid_bg_image_blur"
                style={{
                  backgroundImage: itmPreview.isMsIcon
                    ? urlImage
                    : `url(${urlImage})`,
                }}
              />
            ) : null}
            {itm.type &&
            itm.type.mime &&
            itm.type.mime.indexOf("video") > -1 ? (
              <ReactPlayer
                width="100%"
                height="100%"
                // controls={true}
                url={itmPreview.preview}
              />
            ) : itmPreview.isMsIcon ? (
              <ImagePreview item={itmPreview} key={idx} />
            ) : (
              <img
                className={`${itmPreview.isMsIcon ? "storiesGridMsIcon" : ""}`}
                src={itmPreview.preview}
              />
            )}
          </div>
        );
      } else if (length == 3) {
        result = (
          <div
            className={`idx_${idx} ${
              isGridStyle == 1
                ? `vertical${length}`
                : isGridStyle == 2 && length == 5
                ? "gridColumn5"
                : isGridStyle == 2 && length == 4
                ? "p1Grid4"
                : "p0Grid4"
            } grp${length} ${ itm.type.mime.indexOf("video") > -1?'is-vid-css':''}`}
            key={idx}
          >
            {itm.type &&
            itm.type.mime &&
            itm.type.mime.indexOf("video") == -1 &&
            !itmPreview.isMsIcon ? (
              <div
                className="stories_photo_grid_bg_image_blur"
                style={{
                  backgroundImage: itmPreview.isMsIcon
                    ? urlImage
                    : `url(${urlImage})`,
                }}
              />
            ) : null}
            {itm.type &&
            itm.type.mime &&
            itm.type.mime.indexOf("video") > -1 ? (
              <ReactPlayer
                width="100%"
                height="100%"
                // controls={true}
                url={itmPreview.preview}
              />
            ) : itmPreview.isMsIcon ? (
              <ImagePreview item={itmPreview} key={idx} />
            ) : (
              <img
                className={`${itmPreview.isMsIcon ? "storiesGridMsIcon" : ""}`}
                src={itmPreview.preview}
              />
            )}
          </div>
        );
      } else if (length == 4) {
        result = (
          <div
            className={`idx_${idx} ${
              isGridStyle == 1
                ? `vertical${length}`
                : isGridStyle == 2 && length == 5
                ? "gridColumn5"
                : isGridStyle == 2 && length == 4
                ? "p1Grid4"
                : "p0Grid4"
            } grp${length} ${ itm.type.mime.indexOf("video") > -1?'is-vid-css':''}`}
            key={idx}
          >
            {itm.type &&
            itm.type.mime &&
            itm.type.mime.indexOf("video") == -1 &&
            !itmPreview.isMsIcon ? (
              <div
                className="stories_photo_grid_bg_image_blur"
                style={{
                  backgroundImage: itmPreview.isMsIcon
                    ? urlImage
                    : `url(${urlImage})`,
                }}
              />
            ) : null}
            {itm.type &&
            itm.type.mime &&
            itm.type.mime.indexOf("video") > -1 ? (
              <ReactPlayer
                width="100%"
                height="100%"
                // controls={true}
                url={itmPreview.preview}
              />
            ) : itmPreview.isMsIcon ? (
              <ImagePreview item={itmPreview} key={idx} />
            ) : (
              <img
                className={`${itmPreview.isMsIcon ? "storiesGridMsIcon" : ""}`}
                src={itmPreview.preview}
              />
            )}
          </div>
        );
      } else if (length == 5) {
        result = (
          <div
            className={`idx_${idx} ${
              isGridStyle == 1
                ? `vertical${length}`
                : isGridStyle == 2 && length == 5
                ? "gridColumn5"
                : isGridStyle == 2 && length == 4
                ? "p1Grid4"
                : "p0Grid4"
            } grp${length} ${ itm.type.mime.indexOf("video") > -1?'is-vid-css':''}`}
            key={idx}
          >
            {itm.type &&
            itm.type.mime &&
            itm.type.mime.indexOf("video") == -1 &&
            !itmPreview.isMsIcon ? (
              <div
                className="stories_photo_grid_bg_image_blur"
                style={{
                  backgroundImage: itmPreview.isMsIcon
                    ? urlImage
                    : `url(${urlImage})`,
                }}
              />
            ) : null}
            {itm.type &&
            itm.type.mime &&
            itm.type.mime.indexOf("video") > -1 ? (
              <ReactPlayer
                width="100%"
                height="100%"
                // controls={true}
                url={itmPreview.preview}
              />
            ) : itmPreview.isMsIcon ? (
              <ImagePreview item={itmPreview} key={idx} />
            ) : (
              <img
                className={`${itmPreview.isMsIcon ? "storiesGridMsIcon" : ""}`}
                src={itmPreview.preview}
              />
            )}
          </div>
        );
      }
      // result= <div className={`idx_${idx} ${isGridStyle==1?`vertical${length}`:isGridStyle==2 && length==5?'gridColumn5':
      // isGridStyle==2 && length==4? 'p1Grid4':'p0Grid4'}`}  key={idx}>
      //      {itm.type&&itm.type.mime &&itm.type.mime.indexOf('video')>-1?
      //         <ReactPlayer
      //                 width='100%'
      //                 height='100%'
      //                 controls={true}
      //                 url= {itm.url} />
      //      :
      //      <img src={itm.url}/>
      //      }
      //   </div>
    }
    return result;
  };

  renderSingleAttachment = startSet => {
    let item = startSet[0];
    let itmPreview = uploadPreview(item);
    // let urlImage = itmPreview.isMsIcon?itmPreview: itmPreview.preview && itmPreview.preview.length>0?itmPreview.preview:itmPreview.url
    let urlImage = itmPreview.preview;

    if (item && item.type && item.type.mime.indexOf("video") > -1) {
      return (
        <div className="container grid1 imgFixContainer">
          <ReactPlayer
            width="100%"
            // controls={true}
            url={itmPreview.preview}
          />
        </div>
      );
    } else {
      if (itmPreview.isMsIcon) {
        return (
          <div
            className={`container grid1 no-image-link-preview imgFixContainer`}
          >
            <ImagePreview item={itmPreview} singleItemPreview />
          </div>
        );
      } else {
        return (
          <div className="container grid1 imgFixContainer">
            <div
              className="stories_photo_grid_bg_image_blur"
              style={{ backgroundImage: `url(${urlImage})` }}
            />
            <img
              // onClick={()=> this.seeStory(item)}
              src={itmPreview.preview}
              // className={`${itmPreview.isMsIcon?'storiesGridMsIcon':''}`}
              className="imgFix imgCursor"
            />
          </div>
        );
      }
    }
  };

  renderView = () => {
    let { attachments } = this.state;
    if (attachments && attachments.length > 0) {
      let attachmentsLength = attachments.length;
      let startSet = attachments.slice(0, 5).sort(function (a, b) {
        return b.size - a.size;
      });
      // console.log('startSetP :  ',startSet)
      if (attachmentsLength == 1) {
        return this.renderSingleAttachment(startSet);
      } else if (attachmentsLength > 1) {
        return this.renderGridFormat(attachmentsLength, startSet);
      }
    } else {
      return null;
    }
  };

  render() {
    return (
      <span className="storiesPhotoGridContainer">{this.renderView()}</span>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(StoriesPhotoGrid, axios)));
